module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"asset browser":"Asset Browser","add folder":"Ordner hinzufügen","name":"Name","enter folder name":"Bitte geben Sie den Namen des Ordners an."}}')
  delete Component.options._Ctor
}
